import { drawTextPure } from "@tradingApp/helpers/canvas/draw/textPure";
import { getContextFont } from "@tradingApp/helpers/canvas/getContextFont";
import { measureText } from "@tradingApp/helpers/canvas/measureText";
import type { BasicDrawOptions } from "@tradingApp/helpers/canvas/types";
import colors from "tailwindcss/colors";

interface Params extends BasicDrawOptions {
  header: string;
  description: string;
  spaceY?: number;
  canvasWidth: number;
  canvasHeight: number;
}

export function tradingAssetChartDrawLoadingScreen(params: Params): void {
  const {
    context,
    header,
    description,
    spaceY = 0,
    canvasWidth,
    canvasHeight,
  } = params;

  const measureText1 = measureText(header, (ctx) => {
    ctx.font = getContextFont({ weight: 600, size: 14 });
  });

  const measureText2 = measureText(description, (ctx) => {
    ctx.font = getContextFont({ weight: 500, size: 12 });
  });

  const heightHeader =
    measureText1.actualBoundingBoxAscent +
    measureText1.actualBoundingBoxDescent;

  const heightDescription =
    measureText2.actualBoundingBoxAscent +
    measureText2.actualBoundingBoxDescent;

  const heightTextBox = heightHeader + heightDescription + spaceY;

  context.save();

  drawTextPure({
    context,
    text: header,
    x: 0,
    y: 0,
    translateX: canvasWidth / 2 - measureText1.width / 2,
    translateY: canvasHeight / 2 - heightTextBox / 2,
    contextOptions: {
      font: getContextFont({ weight: 600, size: 14 }),
      fillStyle: colors.white,
      textAlign: "left",
      textBaseline: "top",
    },
  });

  drawTextPure({
    context,
    text: description,
    x: 0,
    y: 0,
    translateX: canvasWidth / 2 - measureText2.width / 2,
    translateY: canvasHeight / 2 - heightTextBox / 2 + heightHeader + spaceY,
    contextOptions: {
      font: getContextFont({ weight: 500, size: 12 }),
      fillStyle: colors.gray[600],
      textAlign: "left",
      textBaseline: "top",
    },
  });

  context.restore();
}
